var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(1724), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(9708), __webpack_require__.e(4408), __webpack_require__.e(5199)]).then(() => (() => ((__webpack_require__(81266)))));
	},
	"./version": () => {
		return __webpack_require__.e(7139).then(() => (() => ((__webpack_require__(27139)))));
	},
	"./versionMatrix": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(3672)]).then(() => (() => ((__webpack_require__(23672)))));
	},
	"./SafetyDetailsDCVC": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(4471)]).then(() => (() => ((__webpack_require__(54471)))));
	},
	"./SafetyEventsDCVC": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(2142)]).then(() => (() => ((__webpack_require__(52142)))));
	},
	"./VehicleHistoryChart": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(4395)]).then(() => (() => ((__webpack_require__(74395)))));
	},
	"./SafetyHealthFleetWideView": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(5719)]).then(() => (() => ((__webpack_require__(25719)))));
	},
	"./SafetyHealthVehicleView": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(986)]).then(() => (() => ((__webpack_require__(60986)))));
	},
	"./SafetyEventsFleetWideView": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(2472)]).then(() => (() => ((__webpack_require__(62472)))));
	},
	"./SafetyEventsVehicleFleetWideView": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(4450)]).then(() => (() => ((__webpack_require__(64450)))));
	},
	"./SafetyEventDetails": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(8113)]).then(() => (() => ((__webpack_require__(98113)))));
	},
	"./VideoLibraryFleetWideView": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(4445)]).then(() => (() => ((__webpack_require__(24445)))));
	},
	"./Notifications": () => {
		return Promise.all([__webpack_require__.e(9244), __webpack_require__.e(4887), __webpack_require__.e(8228), __webpack_require__.e(1724), __webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(375), __webpack_require__.e(2272), __webpack_require__.e(4459), __webpack_require__.e(7620)]).then(() => (() => ((__webpack_require__(67620)))));
	},
	"./VehicleInfoDetailsBox": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(5531)]).then(() => (() => ((__webpack_require__(75531)))));
	},
	"./FuelPerformanceAnalysis": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(1967), __webpack_require__.e(9490), __webpack_require__.e(5436)]).then(() => (() => ((__webpack_require__(35436)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});